
const getValue = (collection,fieldName) => {
  let found = collection.find(obj => obj.fieldName === fieldName);
  return found ? found.value : ""
} 

const getCarBrand = (Car, brandId) => {
  let brand = Car.carBrand.find(brand => brand.id == brandId)
  console.log(Car)
  return brand ? brand.brand : ""
}

const getCarModel = (Car, modelId) => {
  let model = Car.carModel.find(model => model.id == modelId)
  return model ? model.carType : ""
}

const getCarType = (Car, typeId) => {
  let type = Car.carType.find(ctype => ctype.id == typeId)
  return type ? type.type : ""
}

export {
  getValue,
  getCarBrand,
  getCarModel,
  getCarType
}


// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/utils/index.js